import React, { useState, useEffect } from "react";
import { useIntl } from "gatsby-plugin-react-intl";

import Menu from "./Menu";

import styled from "styled-components";
import Button from "../Button";

const BrugerWrapper = styled.div`
  display: none;

  z-index: 5;

  @media (max-width: 1049px) {
    width: 18px;
    height: 18px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-content: center;

    cursor: pointer;
    position: ${({ open }) => (open ? "fixed" : "relative")};
    top: ${({ open }) => (open ? "20px" : "")};
    right: ${({ open }) => (open ? "20px" : "")};

    div {
      background-color: ${(props) => props.color};
      width: 100%;
      height: 2px;
      border-radius: 10px;
      transform-origin: 1px;
      transition: all 0.2s linear;
      margin: auto;

      &:nth-child(1) {
        transform: ${({ open }) => (open ? "rotate(45deg)" : "rotate(0)")};
      }

      &:nth-child(2) {
        opacity: ${({ open }) => (open ? 0 : 1)};
      }

      &:nth-child(3) {
        transform: ${({ open }) => (open ? "rotate(-45deg)" : "rotate(0)")};
      }
    }
  }
`;

const BoxCtaMobile = styled.div`
  display: none;

  @media (max-width: 767px) {
    display: block;
  }
`;

function Burger({ burgerName, color = "#222" }) {
  const intl = useIntl();
  const [open, setOpen] = useState(false);

  function lockScroll(lock) {
    const overflow = lock ? "hidden" : "visible";

    if (typeof window !== "undefined") {
      document.querySelector("html").style.overflow = overflow;
    }
  }

  useEffect(() => {
    lockScroll(open);
  }, [open]);

  return (
    <>
      {(() => {
        switch (burgerName) {
          case "thankyou-page":
            return (
              <>
                <BrugerWrapper
                  color={color}
                  open={open}
                  onClick={() => setOpen(!open)}
                >
                  <div />
                  <div />
                  <div />
                </BrugerWrapper>
                <Menu open={open} nameMenu="thankyou-page">
                  <BoxCtaMobile open={open} onClick={() => setOpen(!open)}>
                    <Button to="/contact/" typeButton="outline">
                      ENTRE EM CONTATO
                    </Button>
                  </BoxCtaMobile>
                </Menu>
              </>
            );

          case "no-scape-partern-stack":
            return (
              <>
                <BrugerWrapper
                  color={color}
                  open={open}
                  onClick={() => setOpen(!open)}
                >
                  <div />
                  <div />
                  <div />
                </BrugerWrapper>
                <Menu open={open} nameMenu="no-scape-partern-stack">
                  <BoxCtaMobile open={open} onClick={() => setOpen(!open)}>
                    <Button typeButton="scroll-to" goTo="#form">
                      {intl.formatMessage({ id: "navbar.btn" })}
                    </Button>
                  </BoxCtaMobile>
                </Menu>
              </>
            );

          case "page-form-no-scape-no-back":
            return <Menu open={open} nameMenu="page-form-no-scape-no-back" />;

          case "page-form-no-scape":
            return <Menu open={open} nameMenu="page-form-no-scape" />;

          default:
            return (
              <>
                <BrugerWrapper
                  color={color}
                  open={open}
                  onClick={() => setOpen(!open)}
                >
                  <div />
                  <div />
                  <div />
                </BrugerWrapper>
                <Menu open={open} />
              </>
            );
        }
      })()}
    </>
  );
}

export default Burger;
